import { getRoles as getRolesRest, getRole as getRoleRest } from '../rest/index.tsx';
import { transformRole, transformRoles } from './transformers.tsx';
import type { RequestRole, RequestRoles } from './types.tsx';

export const requestRoles: RequestRoles = (projectId, isCurrentMember) =>
	getRolesRest(projectId, isCurrentMember).then(transformRoles);

export const requestRole: RequestRole = (projectId, RoleId) =>
	getRoleRest(projectId, RoleId).then(transformRole);
